'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SalesHubLogo = props => {
  return /*#__PURE__*/_jsx("svg", Object.assign({
    enableBackground: "new 0 0 24 24",
    id: "Layer_1",
    version: "1.1",
    viewBox: "0 0 24 24",
    x: "0px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    y: "0px"
  }, props, {
    children: /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsxs("g", {
        children: [/*#__PURE__*/_jsxs("g", {
          children: [/*#__PURE__*/_jsxs("linearGradient", {
            gradientUnits: "userSpaceOnUse",
            id: "SVGID_1_",
            x1: "5.8302",
            x2: "18.11226",
            y1: "10.89782",
            y2: "15.12687",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0%",
              stopColor: "#FF7A59"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "100%",
              stopColor: "#FF805C"
            })]
          }), /*#__PURE__*/_jsx("path", {
            d: "M18.2993,14.58368l-3.6322-11.365c-0.79647-3.22491-5.38095-3.22491-6.17741,0L3.36538,19.25245 C2.87,21.25824,4.38803,23.19679,6.45409,23.19679c0,0,0.94805,0.0693,1.89327-0.58127 c-0.00385-0.00385,3.22131-2.54031,3.22131-2.54031L18.2993,14.58368z",
            fill: "url(#SVGID_1_)"
          }), /*#__PURE__*/_jsx("path", {
            d: "M11.58492,20.05917c0,0,3.4996,2.54368,3.4996,2.54526c0.78732,0.58337,1.61679,0.59236,1.61679,0.59236 c1.2071,0.04342,2.1673-0.50905,2.73097-1.35507c0.47256-0.70927,0.63685-1.59309,0.37394-2.59085l-1.50727-4.66817 L11.58492,20.05917z",
            fill: "#FF805C"
          })]
        }), /*#__PURE__*/_jsxs("g", {
          children: [/*#__PURE__*/_jsxs("linearGradient", {
            gradientUnits: "userSpaceOnUse",
            id: "SVGID_00000097484331456793172400000010865174478066256537_",
            x1: "-12.50924",
            x2: "25.04142",
            y1: "15.11917",
            y2: "15.11917",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "0%",
              stopColor: "#FF9A6D"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "27.089%",
              stopColor: "#FF976B"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "45.53%",
              stopColor: "#FF8E65"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "49.717%",
              stopColor: "#FF8B63"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "80.215%",
              stopColor: "#FF805C"
            })]
          }), /*#__PURE__*/_jsx("path", {
            d: "M4.83974,7.62102l13.84793,10.066 c1.3615,0.98967,1.66288,2.8956,0.67324,4.25706s-2.89556,1.66292-4.25706,0.67324l-13.84793-10.066 c-1.3615-0.98967-1.66288-2.8956-0.67324-4.25706S3.47824,6.63135,4.83974,7.62102z",
            fill: "url(#SVGID_00000097484331456793172400000010865174478066256537_)"
          }), /*#__PURE__*/_jsxs("linearGradient", {
            gradientUnits: "userSpaceOnUse",
            id: "SVGID_00000158745212272112791280000015718731165802809005_",
            x1: "-8.79987",
            x2: "21.9386",
            y1: "10.08596",
            y2: "10.08596",
            children: [/*#__PURE__*/_jsx("stop", {
              offset: "50.688%",
              stopColor: "#FF9167"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "57.135%",
              stopColor: "#FF9A6D"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "70.762%",
              stopColor: "#FFA775"
            }), /*#__PURE__*/_jsx("stop", {
              offset: "83.001%",
              stopColor: "#FFAC78"
            })]
          }), /*#__PURE__*/_jsx("path", {
            d: "M3.04765,7.03836h17.90394 c1.68319,0,3.04759,1.36446,3.04759,3.04759s-1.36441,3.04759-3.04759,3.04759H3.04765 c-1.68319,0-3.04759-1.36446-3.04759-3.04759C0.00005,8.40283,1.36446,7.03836,3.04765,7.03836z",
            fill: "url(#SVGID_00000158745212272112791280000015718731165802809005_)"
          })]
        })]
      }), /*#__PURE__*/_jsx("circle", {
        cx: "20.95239",
        cy: "10.0864",
        fill: "#FF7A59",
        r: "3.04761"
      })]
    })
  }));
};
export default SalesHubLogo;